export default {
  title: "المستخدمين",
  addUser: "إضافة مستخدم",
  editUser: "تعديل مستخدم",
  deleteUser: "حذف مستخدم",
  userDetails: "تفاصيل المستخدم",
  userInformation: "معلومات المستخدم",
  userList: "قائمة المستخدمين",
  name: "الاسم",
  email: "البريد الإلكتروني",
  phone: "الهاتف",
  role: "الدور",
  department: "القسم",
  position: "المنصب",
  status: "الحالة",
  createdAt: "تاريخ الإنشاء",
  lastLogin: "آخر تسجيل دخول",
  actions: "الإجراءات",
  roles: {
    title: "الأدوار",
    addRole: "إضافة دور",
    editRole: "تعديل دور",
    deleteRole: "حذف دور",
    roleName: "اسم الدور",
    permissions: "الصلاحيات",
    assignPermissions: "تعيين الصلاحيات",
  },
  permissions: {
    title: "الصلاحيات",
    view: "عرض",
    create: "إنشاء",
    edit: "تعديل",
    delete: "حذف",
    manage: "إدارة",
  },
  departments: {
    title: "الأقسام",
    addDepartment: "إضافة قسم",
    editDepartment: "تعديل قسم",
    deleteDepartment: "حذف قسم",
    departmentName: "اسم القسم",
    manager: "المدير",
    description: "الوصف",
  },
  team: {
    title: "الفريق",
    members: "أعضاء الفريق",
    addMember: "إضافة عضو",
    removeMember: "إزالة عضو",
  },
};
